export type TopupMethod = 'promptpay' | 'truewallet' | 'internetBank' | 'creditCard';

export const MONEY_GREEN = '#22c55e';
export const MONEY_GREEN_DEEP = '#0c2e15';
